var _defs, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRex = function SvgRex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rex_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.036,
    cy: 11.998,
    r: 11.5,
    className: "rex_svg__a"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.786,
    cy: 7.748,
    r: 2.25,
    className: "rex_svg__a"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.286,
    cy: 17.748,
    r: 1.25,
    className: "rex_svg__a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.786,
    cy: 10.248,
    r: 1.75,
    className: "rex_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.036 7.5a9.3 9.3 0 0 1 6 2.5M19.135 11.964l.4.534s1.5 2 1.5 6.5M16.859 1.555l.177.445a19.2 19.2 0 0 1 1 6.662M17.536 11.5a10.3 10.3 0 0 1-2.136 5.681M13.688 18.846l-.152.154s-2.5 2.5-8 2.5M12.036.5a17.1 17.1 0 0 0-3.25 5",
    className: "rex_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.618 9.672 7.536 10a12.7 12.7 0 0 0 1 8c1.7 3.406 6 5 6 5l.373.139M6.536 7.748S2.7 8.023.761 9.721",
    className: "rex_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m.816 14.532.22-.034s6.881-1.058 12.474 2.27",
    className: "rex_svg__a"
  })));
};
export default SvgRex;